import {
  DASHBOARD_REPORT_REQUEST,
  DASHBOARD_REPORT_SUCCESS,
  DASHBOARD_REPORT_FAILURE,
  DASHBOARD_PURCHASE_DUE_BILLS_REQUEST,
  DASHBOARD_PURCHASE_DUE_BILLS_SUCCESS,
  DASHBOARD_PURCHASE_DUE_BILLS_FAILURE,
  DASHBOARD_SALES_DUE_BILLS_REQUEST,
  DASHBOARD_SALES_DUE_BILLS_SUCCESS,
  DASHBOARD_SALES_DUE_BILLS_FAILURE,
  DASHBOARD_SALES_DATA_CHART_BILLS_REQUEST,
  DASHBOARD_SALES_DATA_CHART_BILLS_SUCCESS,
  DASHBOARD_SALES_DATA_CHART_BILLS_FAILURE,
  DASHBOARD_RECEIVABLE_OUTSTANDING_REQUEST,
  DASHBOARD_RECEIVABLE_OUTSTANDING_SUCCESS,
  DASHBOARD_RECEIVABLE_OUTSTANDING_FAILURE,
  DASHBOARD_PAYABLE_OUTSTANDING_REQUEST,
  DASHBOARD_PAYABLE_OUTSTANDING_SUCCESS,
  DASHBOARD_PAYABLE_OUTSTANDING_FAILURE,
  DASHBOARD_REMINDER_REQUEST,
  DASHBOARD_REMINDER_SUCCESS,
  DASHBOARD_REMINDER_FAILURE,
  DASHBOARD_EWAYBILL_PENDING_CLOSUER_REQUEST,
  DASHBOARD_EWAYBILL_PENDING_CLOSUER_SUCCESS,
  DASHBOARD_EWAYBILL_PENDING_CLOSUER_FAILURE,
  DASHBOARD_ORDER_ITEM_WISE_BALANCE_QTY_DATA_REQUEST,
  DASHBOARD_ORDER_ITEM_WISE_BALANCE_QTY_DATA_SUCCESS,
  DASHBOARD_ORDER_ITEM_WISE_BALANCE_QTY_DATA_FAILURE,

  DASHBOARD_CHALLAN_ITEM_WISE_QTY_DATA_REQUEST,
  DASHBOARD_CHALLAN_ITEM_WISE_QTY_DATA_SUCCESS,
  DASHBOARD_CHALLAN_ITEM_WISE_QTY_DATA_FAILURE,

  DASHBOARD_SCHEDULE_BALANCE_QTY_DATA_REQUEST,
  DASHBOARD_SCHEDULE_BALANCE_QTY_DATA_SUCCESS,
  DASHBOARD_SCHEDULE_BALANCE_QTY_DATA_FAILURE,

  DASHBOARD_PENDING_SCHEDULE_QTY_DATA_REQUEST,
  DASHBOARD_PENDING_SCHEDULE_QTY_DATA_SUCCESS,
  DASHBOARD_PENDING_SCHEDULE_QTY_DATA_FAILURE
} from "../types/dashboard-report-types";

const initialState = {
  dashboard: {},
  receivableOutstanding: {},
  payableOutstanding: {},
  purchaseDueBills: {},
  salesDueBills: {},
  salesDataChart: {},
  reminders: [],
  eWayBillPendingClosures: [],
  orderItemWiseBalanceQtyData: {},
  challanItemWiseQtyData: {},
  orderScheduleBalanceQtyData: {},
  pendingScheduleQtyData: {},
  loading: false,
  error: null,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case DASHBOARD_REPORT_REQUEST:
    case DASHBOARD_PURCHASE_DUE_BILLS_REQUEST:
    case DASHBOARD_SALES_DUE_BILLS_REQUEST: 
    case DASHBOARD_SALES_DATA_CHART_BILLS_REQUEST:
    case DASHBOARD_RECEIVABLE_OUTSTANDING_REQUEST:
    case DASHBOARD_PAYABLE_OUTSTANDING_REQUEST:
    case DASHBOARD_REMINDER_REQUEST:
    case DASHBOARD_EWAYBILL_PENDING_CLOSUER_REQUEST:
    case DASHBOARD_ORDER_ITEM_WISE_BALANCE_QTY_DATA_REQUEST:
    case DASHBOARD_CHALLAN_ITEM_WISE_QTY_DATA_REQUEST:
    case DASHBOARD_SCHEDULE_BALANCE_QTY_DATA_REQUEST:
    case DASHBOARD_PENDING_SCHEDULE_QTY_DATA_REQUEST:
    {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case DASHBOARD_REPORT_SUCCESS: {
      return {
        ...state,
        dashboard: action.payload || {},
        loading: false,
        error: null
      };
    }
    case DASHBOARD_RECEIVABLE_OUTSTANDING_SUCCESS: {
      return {
        ...state,
        receivableOutstanding: action.payload || {},
        loading: false,
        error: null
      };
    }
    case DASHBOARD_REMINDER_SUCCESS: {
      return {
        ...state,
        reminders: [...action.payload],
        loading: false,
        error: null
      };
    }
    case DASHBOARD_EWAYBILL_PENDING_CLOSUER_SUCCESS: {
      return {
        ...state,
        eWayBillPendingClosures: [...action.payload],
        loading: false,
        error: null
      };
    }
    case DASHBOARD_PAYABLE_OUTSTANDING_SUCCESS: {
      return {
        ...state,
        payableOutstanding: action.payload || {},
        loading: false,
        error: null
      };
    }
    case DASHBOARD_PURCHASE_DUE_BILLS_SUCCESS:
      return {
        ...state,
        purchaseDueBills: action.payload || {},
        loading: false,
        error: null
      };

    case DASHBOARD_SALES_DUE_BILLS_SUCCESS:
      return {
        ...state,
        salesDueBills: action.payload || {},
        loading: false,
        error: null
      };

    case DASHBOARD_SALES_DATA_CHART_BILLS_SUCCESS:
      return {
          ...state,
          salesDataChart: action.payload || {},
          loading: false,
          error: null
      };

    case DASHBOARD_ORDER_ITEM_WISE_BALANCE_QTY_DATA_SUCCESS:
      return {
          ...state,
          orderItemWiseBalanceQtyData: action.payload || {},
          loading: false,
          error: null
      };
    case DASHBOARD_CHALLAN_ITEM_WISE_QTY_DATA_SUCCESS:
      return {
          ...state,
          challanItemWiseQtyData: action.payload || {},
          loading: false,
          error: null
      };
    case DASHBOARD_SCHEDULE_BALANCE_QTY_DATA_SUCCESS:
      return {
          ...state,
          orderScheduleBalanceQtyData: action.payload || {},
          loading: false,
          error: null
      };
    case DASHBOARD_PENDING_SCHEDULE_QTY_DATA_SUCCESS:
      return {
          ...state,
          pendingScheduleQtyData: action.payload || {},
          loading: false,
          error: null
      };
    case DASHBOARD_REPORT_FAILURE:
    case DASHBOARD_PURCHASE_DUE_BILLS_FAILURE:
    case DASHBOARD_SALES_DUE_BILLS_FAILURE:
    case DASHBOARD_SALES_DATA_CHART_BILLS_FAILURE:
    case DASHBOARD_RECEIVABLE_OUTSTANDING_FAILURE:
    case DASHBOARD_PAYABLE_OUTSTANDING_FAILURE:
    case DASHBOARD_REMINDER_FAILURE:
    case DASHBOARD_EWAYBILL_PENDING_CLOSUER_FAILURE:
    case DASHBOARD_ORDER_ITEM_WISE_BALANCE_QTY_DATA_FAILURE:
    case DASHBOARD_CHALLAN_ITEM_WISE_QTY_DATA_FAILURE:
    case DASHBOARD_SCHEDULE_BALANCE_QTY_DATA_FAILURE:
    case DASHBOARD_PENDING_SCHEDULE_QTY_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    default:
      return state;
  }
};

export default dashboardReducer;
